
var app = angular.module('directives.paymentCreate', []);

require('./directives/paymentCreate.js');
require('./stylesheets/paymentCreate.scss');
require('./templates/index.html');

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentCreate/index.js
 ** module id = 200
 ** module chunks = 1
 **/